import { render, staticRenderFns } from "./VersionMessageEditor.vue?vue&type=template&id=2338498d&scoped=true"
import script from "./VersionMessageEditor.vue?vue&type=script&lang=js"
export * from "./VersionMessageEditor.vue?vue&type=script&lang=js"
import style0 from "./VersionMessageEditor.vue?vue&type=style&index=0&id=2338498d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2338498d",
  null
  
)

export default component.exports